import HundredBricksAPIError from '../HundredBricksAPIError';
class LoginError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('LoginError', ...args);
    }
}
export default LoginError;
